/* AUTO-GENERATED by INYRON Impact Biology. */
export const IMPACT_BIOLOGY_PROFILES={
  "iron-bulwark": {
    "id": "bio-iron-bulwark",
    "ownerId": "iron-bulwark",
    "family": "organic",
    "fluidKind": "blood",
    "baseColor": "#7a1211",
    "highlightColor": "#d51c2f",
    "emissive": 0,
    "viscosity": 0.69,
    "mist": 0.148,
    "droplets": 16,
    "decalKind": "wet-organic",
    "dissipation": 18,
    "decalRadius": 0.18,
    "streakChance": -0.06,
    "textureUrl": "/impact-biology/actors/iron-bulwark.png",
    "reactions": {
      "fire": "char-steam",
      "ice": "freeze",
      "energy": "ionize",
      "void": "phase-dispersion",
      "light": "radiant-vaporize"
    }
  },
  "plague-harbinger": {
    "id": "bio-plague-harbinger",
    "ownerId": "plague-harbinger",
    "family": "plague",
    "fluidKind": "virulent-bile",
    "baseColor": "#65871f",
    "highlightColor": "#bde665",
    "emissive": 0.55,
    "viscosity": 0.76,
    "mist": 0.362,
    "droplets": 9,
    "decalKind": "plague-corrosion",
    "dissipation": 21.4,
    "decalRadius": 0.225,
    "streakChance": 0.43,
    "textureUrl": "/impact-biology/actors/plague-harbinger.png",
    "reactions": {
      "fire": "char-steam",
      "ice": "freeze",
      "energy": "ionize",
      "void": "phase-dispersion",
      "light": "radiant-vaporize"
    }
  },
  "echo-dancer": {
    "id": "bio-echo-dancer",
    "ownerId": "echo-dancer",
    "family": "organic",
    "fluidKind": "blood",
    "baseColor": "#8c0925",
    "highlightColor": "#d11d29",
    "emissive": -0.07,
    "viscosity": 0.78,
    "mist": 0.202,
    "droplets": 14,
    "decalKind": "wet-organic",
    "dissipation": 16.6,
    "decalRadius": 0.225,
    "streakChance": -0.05,
    "textureUrl": "/impact-biology/actors/echo-dancer.png",
    "reactions": {
      "fire": "char-steam",
      "ice": "freeze",
      "energy": "ionize",
      "void": "phase-dispersion",
      "light": "radiant-vaporize"
    }
  },
  "guardian-knight": {
    "id": "bio-guardian-knight",
    "ownerId": "guardian-knight",
    "family": "celestial",
    "fluidKind": "luminous-essence",
    "baseColor": "#f4d869",
    "highlightColor": "#fff5c2",
    "emissive": 2.335,
    "viscosity": 0.13,
    "mist": 0.798,
    "droplets": 4,
    "decalKind": "radiant-mark",
    "dissipation": 7.7,
    "decalRadius": 0.255,
    "streakChance": 0.42,
    "textureUrl": "/impact-biology/actors/guardian-knight.png",
    "reactions": {
      "fire": "char-steam",
      "ice": "freeze",
      "energy": "ionize",
      "void": "eclipse-burn",
      "light": "radiant-vaporize"
    }
  },
  "arcane-mage": {
    "id": "bio-arcane-mage",
    "ownerId": "arcane-mage",
    "family": "rift",
    "fluidKind": "rift-essence",
    "baseColor": "#3d37c9",
    "highlightColor": "#afb8f5",
    "emissive": 1.545,
    "viscosity": 0.2,
    "mist": 0.626,
    "droplets": 4,
    "decalKind": "rift-burn",
    "dissipation": 4.9,
    "decalRadius": 0.195,
    "streakChance": 0.21,
    "textureUrl": "/impact-biology/actors/arcane-mage.png",
    "reactions": {
      "fire": "char-steam",
      "ice": "freeze",
      "energy": "ionize",
      "void": "phase-dispersion",
      "light": "radiant-vaporize"
    }
  },
  "cyber-vanguard": {
    "id": "bio-cyber-vanguard",
    "ownerId": "cyber-vanguard",
    "family": "organic",
    "fluidKind": "blood",
    "baseColor": "#672129",
    "highlightColor": "#ab3f4d",
    "emissive": -0.035,
    "viscosity": 0.69,
    "mist": 0.292,
    "droplets": 16,
    "decalKind": "wet-organic",
    "dissipation": 17.3,
    "decalRadius": 0.3,
    "streakChance": 0.22,
    "textureUrl": "/impact-biology/actors/cyber-vanguard.png",
    "reactions": {
      "fire": "char-steam",
      "ice": "freeze",
      "energy": "ionize",
      "void": "phase-dispersion",
      "light": "radiant-vaporize"
    }
  },
  "dragon-summoner": {
    "id": "bio-dragon-summoner",
    "ownerId": "dragon-summoner",
    "family": "organic",
    "fluidKind": "blood",
    "baseColor": "#870917",
    "highlightColor": "#d41c2f",
    "emissive": -0.105,
    "viscosity": 0.645,
    "mist": 0.256,
    "droplets": 15,
    "decalKind": "wet-organic",
    "dissipation": 15.9,
    "decalRadius": 0.27,
    "streakChance": 0.33,
    "textureUrl": "/impact-biology/actors/dragon-summoner.png",
    "reactions": {
      "fire": "char-steam",
      "ice": "freeze",
      "energy": "ionize",
      "void": "phase-dispersion",
      "light": "radiant-vaporize"
    }
  },
  "reaper-executioner": {
    "id": "bio-reaper-executioner",
    "ownerId": "reaper-executioner",
    "family": "void",
    "fluidKind": "void-matter",
    "baseColor": "#06020b",
    "highlightColor": "#7c3aed",
    "emissive": 0.745,
    "viscosity": 0.32,
    "mist": 0.74,
    "droplets": 7,
    "decalKind": "void-scar",
    "dissipation": 5.9,
    "decalRadius": 0.24,
    "streakChance": 0.08,
    "textureUrl": "/impact-biology/actors/reaper-executioner.png",
    "reactions": {
      "fire": "violet-vapor",
      "ice": "freeze",
      "energy": "ionize",
      "void": "phase-dispersion",
      "light": "purge-flare"
    }
  },
  "revenant": {
    "id": "bio-revenant",
    "ownerId": "revenant",
    "family": "revenant",
    "fluidKind": "spectral-ichor",
    "baseColor": "#3b1348",
    "highlightColor": "#9b7afd",
    "emissive": 0.685,
    "viscosity": 0.355,
    "mist": 0.502,
    "droplets": 8,
    "decalKind": "spectral-residue",
    "dissipation": 8.3,
    "decalRadius": 0.225,
    "streakChance": -0.01,
    "textureUrl": "/impact-biology/actors/revenant.png",
    "reactions": {
      "fire": "char-steam",
      "ice": "freeze",
      "energy": "ionize",
      "void": "phase-dispersion",
      "light": "radiant-vaporize"
    }
  },
  "rift-weaver": {
    "id": "bio-rift-weaver",
    "ownerId": "rift-weaver",
    "family": "rift",
    "fluidKind": "rift-essence",
    "baseColor": "#2c70a9",
    "highlightColor": "#97d2d1",
    "emissive": 1.755,
    "viscosity": 0.215,
    "mist": 0.716,
    "droplets": 4,
    "decalKind": "rift-burn",
    "dissipation": 9.1,
    "decalRadius": 0.27,
    "streakChance": 0.3,
    "textureUrl": "/impact-biology/actors/rift-weaver.png",
    "reactions": {
      "fire": "char-steam",
      "ice": "freeze",
      "energy": "ionize",
      "void": "phase-dispersion",
      "light": "radiant-vaporize"
    }
  },
  "tidal-warden": {
    "id": "bio-tidal-warden",
    "ownerId": "tidal-warden",
    "family": "tidal",
    "fluidKind": "brine-ichor",
    "baseColor": "#188bce",
    "highlightColor": "#9de1ff",
    "emissive": 0.415,
    "viscosity": 0.655,
    "mist": 0.354,
    "droplets": 13,
    "decalKind": "brine-splash",
    "dissipation": 14.3,
    "decalRadius": 0.285,
    "streakChance": 0.21,
    "textureUrl": "/impact-biology/actors/tidal-warden.png",
    "reactions": {
      "fire": "char-steam",
      "ice": "freeze",
      "energy": "ionize",
      "void": "phase-dispersion",
      "light": "radiant-vaporize"
    }
  },
  "timekeeper": {
    "id": "bio-timekeeper",
    "ownerId": "timekeeper",
    "family": "rift",
    "fluidKind": "rift-essence",
    "baseColor": "#5750bb",
    "highlightColor": "#c9bac2",
    "emissive": 1.65,
    "viscosity": 0.26,
    "mist": 0.752,
    "droplets": 4,
    "decalKind": "rift-burn",
    "dissipation": 7,
    "decalRadius": 0.3,
    "streakChance": 0.27,
    "textureUrl": "/impact-biology/actors/timekeeper.png",
    "reactions": {
      "fire": "char-steam",
      "ice": "freeze",
      "energy": "ionize",
      "void": "phase-dispersion",
      "light": "radiant-vaporize"
    }
  },
  "void-seraph": {
    "id": "bio-void-seraph",
    "ownerId": "void-seraph",
    "family": "void",
    "fluidKind": "void-matter",
    "baseColor": "#0c0216",
    "highlightColor": "#7134d9",
    "emissive": 0.815,
    "viscosity": 0.26,
    "mist": 0.668,
    "droplets": 3,
    "decalKind": "void-scar",
    "dissipation": 7.3,
    "decalRadius": 0.18,
    "streakChance": 0.23,
    "textureUrl": "/impact-biology/actors/void-seraph.png",
    "reactions": {
      "fire": "violet-vapor",
      "ice": "freeze",
      "energy": "ionize",
      "void": "phase-dispersion",
      "light": "purge-flare"
    }
  },
  "shadow-assassin": {
    "id": "bio-shadow-assassin",
    "ownerId": "shadow-assassin",
    "family": "void",
    "fluidKind": "void-matter",
    "baseColor": "#130f17",
    "highlightColor": "#6c38c5",
    "emissive": 0.955,
    "viscosity": 0.215,
    "mist": 0.794,
    "droplets": 7,
    "decalKind": "void-scar",
    "dissipation": 10.1,
    "decalRadius": 0.285,
    "streakChance": 0.38,
    "textureUrl": "/impact-biology/actors/shadow-assassin.png",
    "reactions": {
      "fire": "violet-vapor",
      "ice": "freeze",
      "energy": "ionize",
      "void": "phase-dispersion",
      "light": "purge-flare"
    }
  },
  "elysama": {
    "id": "bio-elysama",
    "ownerId": "elysama",
    "family": "organic",
    "fluidKind": "blood",
    "baseColor": "#962f39",
    "highlightColor": "#d2182a",
    "emissive": 0.035,
    "viscosity": 0.705,
    "mist": 0.166,
    "droplets": 13,
    "decalKind": "wet-organic",
    "dissipation": 18.7,
    "decalRadius": 0.195,
    "streakChance": -0.14,
    "textureUrl": "/impact-biology/actors/elysama.png",
    "reactions": {
      "fire": "char-steam",
      "ice": "freeze",
      "energy": "ionize",
      "void": "phase-dispersion",
      "light": "radiant-vaporize"
    }
  },
  "sentinel": {
    "id": "bio-sentinel",
    "ownerId": "sentinel",
    "family": "organic",
    "fluidKind": "blood",
    "baseColor": "#7f232a",
    "highlightColor": "#cf2b3a",
    "emissive": -0.07,
    "viscosity": 0.72,
    "mist": 0.238,
    "droplets": 14,
    "decalKind": "wet-organic",
    "dissipation": 16.6,
    "decalRadius": 0.255,
    "streakChance": 0.33,
    "textureUrl": "/impact-biology/actors/sentinel.png",
    "reactions": {
      "fire": "char-steam",
      "ice": "freeze",
      "energy": "ionize",
      "void": "phase-dispersion",
      "light": "radiant-vaporize"
    }
  },
  "sentinel-builder": {
    "id": "bio-sentinel-builder",
    "ownerId": "sentinel-builder",
    "family": "organic",
    "fluidKind": "blood",
    "baseColor": "#8d281c",
    "highlightColor": "#d3162d",
    "emissive": -0.07,
    "viscosity": 0.795,
    "mist": 0.238,
    "droplets": 14,
    "decalKind": "wet-organic",
    "dissipation": 16.6,
    "decalRadius": 0.255,
    "streakChance": -0.1,
    "textureUrl": "/impact-biology/actors/sentinel-builder.png",
    "reactions": {
      "fire": "char-steam",
      "ice": "freeze",
      "energy": "ionize",
      "void": "phase-dispersion",
      "light": "radiant-vaporize"
    }
  },
  "alien-commander": {
    "id": "bio-alien-commander",
    "ownerId": "alien-commander",
    "family": "xeno",
    "fluidKind": "plasma-hemolymph",
    "baseColor": "#37d672",
    "highlightColor": "#aefbcf",
    "emissive": 1.25,
    "viscosity": 0.49,
    "mist": 0.304,
    "droplets": 13,
    "decalKind": "xeno-plasma",
    "dissipation": 12,
    "decalRadius": 0.21,
    "streakChance": 0.38,
    "textureUrl": "/impact-biology/actors/alien-commander.png",
    "reactions": {
      "fire": "char-steam",
      "ice": "freeze",
      "energy": "plasma-overcharge",
      "void": "phase-dispersion",
      "light": "radiant-vaporize"
    }
  },
  "quantum-archmage": {
    "id": "bio-quantum-archmage",
    "ownerId": "quantum-archmage",
    "family": "rift",
    "fluidKind": "rift-essence",
    "baseColor": "#3254e0",
    "highlightColor": "#97c6ff",
    "emissive": 1.72,
    "viscosity": 0.14,
    "mist": 0.662,
    "droplets": 5,
    "decalKind": "rift-burn",
    "dissipation": 8.4,
    "decalRadius": 0.225,
    "streakChance": 0.29,
    "textureUrl": "/impact-biology/actors/quantum-archmage.png",
    "reactions": {
      "fire": "char-steam",
      "ice": "freeze",
      "energy": "ionize",
      "void": "phase-dispersion",
      "light": "radiant-vaporize"
    }
  },
  "wisp-warden": {
    "id": "bio-wisp-warden",
    "ownerId": "wisp-warden",
    "family": "wisp",
    "fluidKind": "spirit-essence",
    "baseColor": "#98eaea",
    "highlightColor": "#ffffff",
    "emissive": 2.155,
    "viscosity": 0.155,
    "mist": 0.786,
    "droplets": 2,
    "decalKind": "spirit-glow",
    "dissipation": 7.1,
    "decalRadius": 0.195,
    "streakChance": 0,
    "textureUrl": "/impact-biology/actors/wisp-warden.png",
    "reactions": {
      "fire": "char-steam",
      "ice": "condense-essence",
      "energy": "ionize",
      "void": "phase-dispersion",
      "light": "radiant-vaporize"
    }
  },
  "elyon-protagonist": {
    "id": "bio-elyon-protagonist",
    "ownerId": "elyon-protagonist",
    "family": "rift",
    "fluidKind": "rift-essence",
    "baseColor": "#5d5fb4",
    "highlightColor": "#c9ccc2",
    "emissive": 1.615,
    "viscosity": 0.2,
    "mist": 0.644,
    "droplets": 3,
    "decalKind": "rift-burn",
    "dissipation": 6.3,
    "decalRadius": 0.21,
    "streakChance": 0.32,
    "textureUrl": "/impact-biology/actors/elyon-protagonist.png",
    "reactions": {
      "fire": "char-steam",
      "ice": "freeze",
      "energy": "ionize",
      "void": "phase-dispersion",
      "light": "radiant-vaporize"
    }
  },
  "jhadson-first-light": {
    "id": "bio-jhadson-first-light",
    "ownerId": "jhadson-first-light",
    "family": "celestial",
    "fluidKind": "luminous-essence",
    "baseColor": "#f6c955",
    "highlightColor": "#fff7e8",
    "emissive": 2.3,
    "viscosity": 0.055,
    "mist": 0.744,
    "droplets": 4,
    "decalKind": "radiant-mark",
    "dissipation": 7,
    "decalRadius": 0.21,
    "streakChance": 0.17,
    "textureUrl": "/impact-biology/actors/jhadson-first-light.png",
    "reactions": {
      "fire": "char-steam",
      "ice": "freeze",
      "energy": "ionize",
      "void": "eclipse-burn",
      "light": "radiant-vaporize"
    }
  },
  "celestial-angel": {
    "id": "bio-celestial-angel",
    "ownerId": "celestial-angel",
    "family": "celestial",
    "fluidKind": "luminous-essence",
    "baseColor": "#efdc9e",
    "highlightColor": "#fbfbfe",
    "emissive": 2.3,
    "viscosity": 0.16,
    "mist": 0.798,
    "droplets": 6,
    "decalKind": "radiant-mark",
    "dissipation": 7,
    "decalRadius": 0.255,
    "streakChance": 0.29,
    "textureUrl": "/impact-biology/actors/celestial-angel.png",
    "reactions": {
      "fire": "char-steam",
      "ice": "freeze",
      "energy": "ionize",
      "void": "eclipse-burn",
      "light": "radiant-vaporize"
    }
  },
  "shatterkin": {
    "id": "bio-shatterkin",
    "ownerId": "shatterkin",
    "family": "crystal",
    "fluidKind": "crystalline-lymph",
    "baseColor": "#63cce2",
    "highlightColor": "#e7f3f7",
    "emissive": 1.22,
    "viscosity": 0.56,
    "mist": 0.086,
    "droplets": 7,
    "decalKind": "crystal-fracture",
    "dissipation": 23.4,
    "decalRadius": 0.195,
    "streakChance": 0.21,
    "textureUrl": "/impact-biology/actors/shatterkin.png",
    "reactions": {
      "fire": "thermal-fracture",
      "ice": "brittle-shatter",
      "energy": "ionize",
      "void": "phase-dispersion",
      "light": "radiant-vaporize"
    }
  },
  "tidebound": {
    "id": "bio-tidebound",
    "ownerId": "tidebound",
    "family": "tidal",
    "fluidKind": "brine-ichor",
    "baseColor": "#2894c8",
    "highlightColor": "#afecff",
    "emissive": 0.485,
    "viscosity": 0.535,
    "mist": 0.282,
    "droplets": 12,
    "decalKind": "brine-splash",
    "dissipation": 15.7,
    "decalRadius": 0.225,
    "streakChance": 0.27,
    "textureUrl": "/impact-biology/actors/tidebound.png",
    "reactions": {
      "fire": "char-steam",
      "ice": "freeze",
      "energy": "ionize",
      "void": "phase-dispersion",
      "light": "radiant-vaporize"
    }
  },
  "warden": {
    "id": "bio-warden",
    "ownerId": "warden",
    "family": "organic",
    "fluidKind": "blood",
    "baseColor": "#77202f",
    "highlightColor": "#cd293d",
    "emissive": -0.07,
    "viscosity": 0.69,
    "mist": 0.256,
    "droplets": 12,
    "decalKind": "wet-organic",
    "dissipation": 16.6,
    "decalRadius": 0.27,
    "streakChance": 0.06,
    "textureUrl": "/impact-biology/actors/warden.png",
    "reactions": {
      "fire": "char-steam",
      "ice": "freeze",
      "energy": "ionize",
      "void": "phase-dispersion",
      "light": "radiant-vaporize"
    }
  },
  "vaelthar-astral-architect": {
    "id": "bio-vaelthar-astral-architect",
    "ownerId": "vaelthar-astral-architect",
    "family": "aetherborn",
    "fluidKind": "astral",
    "baseColor": "#b44eff",
    "highlightColor": "#ebcbff",
    "emissive": 1.745,
    "viscosity": 0.24,
    "mist": 0.666,
    "droplets": 3,
    "decalKind": "astral-residue",
    "dissipation": 4.9,
    "decalRadius": 0.195,
    "streakChance": 0.19,
    "textureUrl": "/impact-biology/actors/vaelthar-astral-architect.png",
    "reactions": {
      "fire": "char-steam",
      "ice": "freeze",
      "energy": "ionize",
      "void": "phase-dispersion",
      "light": "radiant-vaporize"
    }
  }
} as const
export type ImpactBiologyOwnerId=keyof typeof IMPACT_BIOLOGY_PROFILES
export function impactBiologyFor(id:string){return IMPACT_BIOLOGY_PROFILES[id as ImpactBiologyOwnerId]??IMPACT_BIOLOGY_PROFILES['iron-bulwark']}
